module.exports = __webpack_public_path__ + "img/sumdes_320.a6aece20.png";